import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Nav.css";

export default function Nav() {
  const location = useLocation();

  // Fonction pour déterminer si un lien est actif
  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="navbar">
      {/* Titre principal */}
      <Link to="/" className="navbar-title-link">
        <h1 className="navbar-title">
          Les Machines Fantastiques de Séraphin Clerc
        </h1>
      </Link>

      {/* Menu principal */}
      <nav role="navigation" aria-label="Navigation principale">
        <ul className="nav-list">
          <li>
            <Link 
              to="/" 
              className={isActiveLink("/") ? "active" : ""}
              aria-current={isActiveLink("/") ? "page" : undefined}
            >
              Biographie
            </Link>
          </li>
          <li>
            <Link 
              to="/machines" 
              className={isActiveLink("/machines") ? "active" : ""}
              aria-current={isActiveLink("/machines") ? "page" : undefined}
            >
              Machines
            </Link>
          </li>
          <li>
            <Link 
              to="/maquettes" 
              className={isActiveLink("/maquettes") ? "active" : ""}
              aria-current={isActiveLink("/maquettes") ? "page" : undefined}
            >
              Maquettes
            </Link>
          </li>
          <li>
            <Link 
              to="/figurines" 
              className={isActiveLink("/figurines") ? "active" : ""}
              aria-current={isActiveLink("/figurines") ? "page" : undefined}
            >
              Figurines
            </Link>
          </li>
          <li>
            <Link 
              to="/exposition" 
              className={isActiveLink("/exposition") ? "active" : ""}
              aria-current={isActiveLink("/exposition") ? "page" : undefined}
            >
              Exposition
            </Link>
          </li>
          <li>
            <Link 
              to="/contact" 
              className={isActiveLink("/contact") ? "active" : ""}
              aria-current={isActiveLink("/contact") ? "page" : undefined}
            >
              Contact
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}